// Shared image-resolution helper for the kiosk product views.
//
// The "Scans On/Off" toggle (showCardScans) decides whether a product tile shows
// the store's own high-resolution card scan or the generic catalog image:
//   - Scans ON:  show the selected variant's scan (cdn_link), so collectors can
//                inspect the exact card they will receive. Falls back to that
//                copy's catalog art when it has no scan on file.
//   - Scans OFF: show the catalog art.
//
// Centralizing this keeps ProductCard and ProductDetailDialog in agreement so the
// toggle can never be honored in one view and ignored in the other. (TKT-2026-102570)
//
// Catalog art is the art for the copy's OWN printing and language
// (utils/cardArt.js), not `product.cdnImage` as such. `cdnImage` is one render per
// productId: for a WOTC-era Pokemon card it is the 1st Edition photo, so an
// Unlimited copy fell back to the wrong card. With no copy selected the product
// shows the printing every in-stock copy shares, else `cdnImage`. (TKT-2026-107421)
//
// Only a seller's scan counts as a scan. A `cdn_link` holding catalog art (our
// `cards/{productId}.jpg` mirror, a TCGplayer render) is the same productId-level
// photo, so it falls through to the printing-aware art like any copy without a
// scan.
import { productCatalogArt, variantBackScanImage, variantCatalogArt, variantScanImage } from './cardArt';

export function resolveDisplayImage(showCardScans, selectedVariant, product) {
    if (selectedVariant) {
        const scan = showCardScans ? variantScanImage(selectedVariant) : '';
        return scan || variantCatalogArt(product, selectedVariant) || null;
    }
    return productCatalogArt(product) || null;
}

// The BACK of the same copy, or null. TKT-2026-105491.
//
// The scanner captures the back and inventory stores it on the stock row as
// `cdn_back_link`; the kiosk backend returns it on every variant beside
// `cdn_link`. It is offered only with Scans ON (the whole point of the toggle is
// "show me the store's own scans") and only when THIS copy has a back scan on
// file. There is deliberately no fallback: a generic card back is not the card
// the shopper would receive, so with no scan the views stay exactly as they were.
// Held to the same seller-scan rule as the front (TKT-2026-107421).
export function resolveBackImage(showCardScans, selectedVariant) {
    if (!showCardScans || !selectedVariant) return null;
    return variantBackScanImage(selectedVariant) || null;
}
